import { APP_CONFIG } from '@/utils/constants'
import HttpService from "@/utils/httpData"

const getHomeSlide = params =>
{    
    let apiEndpoint = `book/get-homepage-slide`;
    return HttpService.get(apiEndpoint).then(res => {
            return res.data ? res.data : null;
	}).catch(e => {return false});
}
export default{
	getHomeSlide
}